import { AutocompleteInput, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { UserCheck } from "lucide-react";
import {
  Create,
  DateInput,
  DateTimeInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
} from "../common";

const statusChoices = [
  { id: "present", name: "Present" },
  { id: "absent", name: "Absent" },
  { id: "half_day", name: "Half Day" },
  { id: "leave", name: "Leave" },
  { id: "holiday", name: "Holiday" },
  { id: "weekoff", name: "Weekoff" },
];

const sourceChoices = [
  { id: "manual", name: "Manual" },
  { id: "biometric", name: "Biometric" },
  { id: "web", name: "Web" },
  { id: "auto", name: "Auto" },
];

const AttendanceToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Log Attendance" />
  </div>
);

export const AttendanceCreate = () => (
  <Create title="Create Attendance">
    <Card className="form-container">
      <div className="form-header-premium">
        <UserCheck className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">New Attendance Log</h2>
      </div>
      <SimpleForm toolbar={<AttendanceToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReferenceInput source="employee_id" reference="employees">
            <AutocompleteInput label="Employee" optionText="name" />
          </ReferenceInput>
          <DateInput source="date" />
          <SelectInput
            source="status"
            choices={statusChoices}
            defaultValue="present"
          />
          <SelectInput
            source="source"
            choices={sourceChoices}
            defaultValue="manual"
          />
          <DateTimeInput source="check_in" />
          <DateTimeInput source="check_out" />
          <NumberInput source="hours_worked" label="Hours Worked" />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);

